<template>
	<div style="margin-top: 20px;">
		<div class="card">
			<div class="card-header" style="background: none; font-size: 20px; font-weight: bold; line-height: 40px;">通知列表</div>
			<div class="card-body">
				<div class="">
					<el-table :data="tableData" v-loading="loading" style="width: 100%; cursor: pointer;">
						<el-table-column label="标题">
							<template slot-scope="scope">
								<div>{{ scope.row.title }}</div>
							</template>
						</el-table-column>
						<el-table-column label="消息内容" width="600">
							<template slot-scope="scope">
								<div>{{ scope.row.content }}</div>
							</template>
						</el-table-column>
						<el-table-column label="日期" width="120">
							<template slot-scope="scope">
								<div>{{ scope.row.created_at }}</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>	
		<!-- 分页 -->
		<!-- <div class="workbench_paging clearfix">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			 :page-sizes="pageSizes" :page-size="pageSize" :total="help_num" layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div> -->
		<!-- 分页 -->
		
		<pading :help="help_num" :currentPage = "currentPage" :pageSize="pageSize" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pading>
	</div>
</template>

<script>
	import {
		NoticeList
	} from '../../common/api/http.js'
	import Pading from '../../components/paging/index.vue' //分页组件
	export default{
		components:{
			Pading
		},
		data(){
			return{
				tableData: [],
				
				help_num: 1,//总共多少条内容 默认1
				currentPage:1, //当前页的index
				pageSize:10, //每页显示多少条
				loading: false,
			}
		},
		mounted() {
			// 通知列表
			this.informList()
			// 通知列表
		},
		methods:{
			// 每页显示条数 10，20，50，100
			handleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.pageSize = val
				this.informList()
			},
			//当前页的index
			handleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.currentPage = val
				this.informList()
			},
			informList(){
				this.loading = true
				let token = window.sessionStorage.getItem('token')
				NoticeList({
					'api_token': token,
					'page':this.currentPage,
					'page_size':this.pageSize
				}).then(res => {
					// console.log(res)
					if(res.code == 0){
						this.tableData = res.data.notice_list
						this.help_num = parseInt(res.data.total)
					}
					this.loading = false
				}).catch(err => {
					// console.log(err)
					this.loading = false
					this.$message.error(err);
				})
			}
		}
	}
</script>

<style>
</style>
